import React, { PropTypes } from "react";
import classnames from "classnames";
import {
  monthEdgesCalender,
  weeksOfMonthCalender,
  daysOfWeekCalender
} from "../dist/dateUtils";
import { getMods, getModsByCompType } from "../dist/util";
import Week from "./Week";

const clsPrefix = "rc-Months";
const renderHeader = props => {
  if (props.renderHeader) {
    return props.renderHeader(props);
  }

  if (!props.monthNames) {
    return null;
  }

  return (
    <header key="header" className={classnames(`${clsPrefix}-header mt-2`)}>
      {props.date.format(props.monthNameFormat)}
    </header>
  );
};
const renderWeekHeader = props => {
  if (!props.weekdayNames) {
    return null;
  } else {
    return (
      <div className={`${clsPrefix}-weekdays mt-2`}>
        {daysOfWeekCalender(props.date).map((weekday, i) =>
          <div
            key={`weekday-header-${i}`}
            className={classnames(`${clsPrefix}-weekdays-weekday`)}
          >
            {weekday.format(props.weekdayFormat)}
          </div>
        )}
      </div>
    );
  }
};

const Month = props => {
  const { date } = props;
  const edges = monthEdgesCalender(date);

  let { mods, day, week } = props;
  let clsMods, events;

  if (!props.day) {
    day = getModsByCompType("day", mods);
  }

  if (!props.week) {
    week = getModsByCompType("week", mods);
  }

  if (!props.day || !props.week) {
    // this means we're probably just rendering a single month and need to filter our component types again.
    mods = getModsByCompType("month", mods);
  }

  let fWeekMods = week.filter(
    (mod, j) => (mod.date ? mod.date.isSame(date, "month") : true)
  );
  let fDayMods = day.filter(
    (mod, k) => (mod.date ? mod.date.isSame(date, "month") : true)
  );

  const modifiers = getMods(mods, date, clsPrefix, "month");

  if (modifiers) {
    clsMods = modifiers.clsMods;
    events = modifiers.events;
  }

  return (
    <div className={classnames(clsPrefix, clsMods)} {...events}>
      {renderHeader(props)}
      {renderWeekHeader(props)}
      {weeksOfMonthCalender(props.date).map((wDate, i) =>
        <Week
          key={`week-${i}`}
          date={wDate}
          edges={edges}
          mods={fWeekMods}
          day={fDayMods}
        />
      )}
    </div>
  );
};

Month.propTypes = {
 // monthNames: PropTypes.bool,
  //monthNameFormat: PropTypes.string,
 // weekdayNames: PropTypes.bool,
 // weekdayFormat: PropTypes.string,
  //mod: PropTypes.object
};

Month.defaultProps = {
  monthNames: true,
  monthNameFormat: "MMMM",
  weekdayNames: true,
  weekdayFormat: "dd"
};

export default Month;
